export const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

export function addMinutes(time, mins) {
  if (!time) return "";
  const [h, m] = time.split(":").map(Number);
  const total = h * 60 + m + Number(mins || 0);
  const nh = Math.max(0, Math.floor(total / 60)) % 24;
  const nm = ((total % 60) + 60) % 60;
  return `${String(nh).padStart(2, "0")}:${String(nm).padStart(2, "0")}`;
}

export function computeDuration(start, end) {
  if (!start || !end) return 0;
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  return eh * 60 + em - (sh * 60 + sm);
}

export function compareSurface(a, b) {
  const sa = String(a ?? "");
  const sb = String(b ?? "");
  const na = parseInt(sa.match(/\d+/)?.[0]);
  const nb = parseInt(sb.match(/\d+/)?.[0]);
  if (!isNaN(na) && !isNaN(nb) && na !== nb) return na - nb;
  return sa.localeCompare(sb);
}

export function formatSurface(s) {
  const str = String(s ?? "");
  return /^\d+$/.test(str) ? `#${str}` : str;
}

export function detectPackage(g) {
  // If admin explicitly set a package on the game, honor it (overrides auto-detection)
  if (g?.package_override && ["A", "B", "C", "D"].includes(g.package_override)) {
    return g.package_override;
  }
  const refs = (g.referee1_id ? 1 : 0) + (g.referee2_id ? 1 : 0);
  const sc = g.scorer_id ? 1 : 0;
  if (refs === 1 && sc === 0) return "A";
  if (refs === 2 && sc === 0) return "B";
  if (refs === 1 && sc === 1) return "C";
  if (refs === 2 && sc === 1) return "D";
  return null;
}

/**
 * Auto-detected package based on assignments only (ignores override).
 * Used to decide whether to highlight a game as "incomplete".
 */
export function autoDetectedPackage(g) {
  const refs = (g.referee1_id ? 1 : 0) + (g.referee2_id ? 1 : 0);
  const sc = g.scorer_id ? 1 : 0;
  if (refs === 1 && sc === 0) return "A";
  if (refs === 2 && sc === 0) return "B";
  if (refs === 1 && sc === 1) return "C";
  if (refs === 2 && sc === 1) return "D";
  return null;
}

export function formatRelative(iso) {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  const diff = Date.now() - t;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "à l'instant";
  if (min < 60) return `il y a ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `il y a ${h}h`;
  const d = Math.floor(h / 24);
  return `il y a ${d}j`;
}

export function sortGames(games) {
  return [...games].sort((a, b) => {
    const d = (a.date || "").localeCompare(b.date || "");
    if (d !== 0) return d;
    const t = (a.start_time || "").localeCompare(b.start_time || "");
    if (t !== 0) return t;
    return compareSurface(a.surface, b.surface);
  });
}

export function roleLabel(role) {
  return role === "referee1_id" ? "Arbitre 1" : role === "referee2_id" ? "Arbitre 2" : "Marqueur";
}
